/**
 * List of colors for the categories
 */
export const COLORS = {
  creativeProduction: '#00C896',
  criticalUse: '#9569BE',
  development: '#FF7F41',
  selfActualising: '#69B3E7',
  participation: '#FFC72C',
  functionalSkills: '#E68699',
  default: '#003C3C',
};

/**
 * A function that returns the colors with opacity
 *
 * @param opacity 0 to 1
 * @returns colors with opacity
 */
export const colorHexWithOpacity = (colorHex: string, opacity: number) => {
  if (opacity < 0 || opacity > 1) {
    throw new Error('Opacity must be between 0 and 1');
  }

  // convert opacity (0 to 1) to hex (00 to FF)
  const opacityHex = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, '0');

  return `${colorHex}${opacityHex}`;
};

export const COLORS_WITH_OPACITY = (opacity: number) => {
  return {
    creativeProduction: colorHexWithOpacity(COLORS.creativeProduction, opacity),
    criticalUse: colorHexWithOpacity(COLORS.criticalUse, opacity),
    development: colorHexWithOpacity(COLORS.development, opacity),
    selfActualising: colorHexWithOpacity(COLORS.selfActualising, opacity),
    participation: colorHexWithOpacity(COLORS.participation, opacity),
    functionalSkills: colorHexWithOpacity(COLORS.functionalSkills, opacity),
    default: colorHexWithOpacity(COLORS.default, opacity),
  };
};
